import * as actionTypes from "./cartActionType";
import axios from 'axios';
import { checkError, apiTimeout } from './../error';
const { REACT_APP_API_URL } = process.env;

export const addToCart = (data) => {
    return (dispatch) => {
        dispatch(addToCartInit());
        apiTimeout(axios.post(`${REACT_APP_API_URL}/cart/store`, { ...data, sessionId: localStorage.getItem("bhabhuti-session")}))
        .then((response) => {
            dispatch(addToCartSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(addToCartFailure());
            checkError(error);
        })
    };
};

export const addToCartInit = () => ({
    type: actionTypes.ADD_TO_CART
});

export const addToCartFailure = () => ({
    type: actionTypes.ADD_TO_CART_FAILURE
});

export const addToCartSuccess = data => ({
    type: actionTypes.ADD_TO_CART_SUCCESS,
    payload: { data }
});

export const changeAddToFalse = () => {
    return (dispatch) => {
        dispatch(changeAddToFalseInIt());
    };
};

export const changeAddToFalseInIt = () => ({
    type: actionTypes.CHANGE_ADD_TO_FALSE
});

export const updateCart = (data) => {
    return (dispatch) => {
        dispatch(updateCartInit());
        apiTimeout(axios.put(`${REACT_APP_API_URL}/cart/${data.id}/${localStorage.getItem("bhabhuti-session")}`, data))
        .then((response) => {
            dispatch(updateCartSuccess(response.data.data));
            dispatch(fetchCart());
            window.location.reload();
        })
        .catch(function (error) {
            dispatch(updateCartFailure());
            checkError(error);
        })
    };
};

export const updateCartInit = () => ({
    type: actionTypes.UPDATE_CART
});

export const updateCartFailure = () => ({
    type: actionTypes.UPDATE_CART_FAILURE
});

export const updateCartSuccess = data => ({
    type: actionTypes.UPDATE_CART_SUCCESS,
    payload: { data }
});

export const deleteCart = (id) => {
    return (dispatch) => {
        dispatch(deleteCartInit());
        apiTimeout(axios.delete(`${REACT_APP_API_URL}/cart/${id}/${localStorage.getItem("bhabhuti-session")}`, ))
        .then((response) => {
            dispatch(deleteCartSuccess(response.data.data));
            dispatch(fetchCart());
            window.location.reload();
        })
        .catch(function (error) {
            dispatch(deleteCartFailure());
            checkError(error);
        })
    };
};

export const deleteCartInit = () => ({
    type: actionTypes.DELETE_CART
});

export const deleteCartFailure = () => ({
    type: actionTypes.DELETE_CART_FAILURE
});

export const deleteCartSuccess = data => ({
    type: actionTypes.DELETE_CART_SUCCESS,
    payload: { data }
});

export const fetchCart = () => {
    return (dispatch) => {
        dispatch(fetchCartInit());
        apiTimeout(axios.get(`${REACT_APP_API_URL}/cart/${localStorage.getItem("bhabhuti-session")}`))
        .then((response) => {
            dispatch(fetchCartSuccess(response.data.data));
        })
        .catch(function (error) {
            dispatch(fetchCartFailure());
            checkError(error);
        })
    };
};

export const fetchCartInit = () => ({
    type: actionTypes.FETCH_CART
});

export const fetchCartFailure = () => ({
    type: actionTypes.FETCH_CART_FAILURE
});

export const fetchCartSuccess = data => ({
    type: actionTypes.FETCH_CART_SUCCESS,
    payload: { data }
});
